/*
 * askAda opens the assistant on a node with a question: asked at once when
 * send is true, for words the operator wrote themselves, else waiting in the
 * composer to be sent or edited.
 */
import { VIEW_ASSISTANT, navigateTo } from "../appView";
import { askAboutStep } from "../tour/tourStore";

export function askAda(node, question, { send = false, from = "firewall" } = {}) {
  askAboutStep(question, { send });
  navigateTo(VIEW_ASSISTANT, { node, from });
}
